// vendors
import { useMantineTheme } from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import { useLocalStorage } from "@mantine/hooks";
import {
  Header as HeaderMantine,
  MediaQuery,
  Burger,
  Grid,
  ActionIcon,
} from "@mantine/core";
import { IconSun, IconMoonStars } from "@tabler/icons";
import { useSelector, useDispatch } from "react-redux";

// utils
import { toggleNavListState } from "../../redux/reducers/theme";
import User from "./_UserNavbar";
import Logo from "../../components/Logo";
// import Logo from '../../assets/logo/ticketin.svg';

export default function Header() {
  const dispatch = useDispatch();
  const sm = useMediaQuery("(max-width: 800px)");
  const navListOpen = useSelector((state) => state.theme.navListOpen);
  const theme = useMantineTheme();

  const [colorScheme, setColorScheme] = useLocalStorage({
    key: "color-scheme",
  });
  const toggleColorScheme = () => {
    setColorScheme(colorScheme === "light" ? "dark" : "light");
  };

  return (
    <HeaderMantine height={70} p={sm ? "md" : 0}>
      <div style={{ display: "flex", alignItems: "center", height: "100%" }}>
        <MediaQuery largerThan="sm" styles={{ display: "none" }}>
          <Burger
            opened={navListOpen}
            onClick={() => dispatch(toggleNavListState())}
            size="sm"
            color={theme.colors.gray[6]}
            mr="xl"
          />
        </MediaQuery>

        <Grid sx={{ flexDirection: "row", width: "100%", padding: "0 20px" }}>
          <Grid.Col
            xs={6}
            sx={
              sm
                ? {
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }
                : { display: "flex", alignItems: "center" }
            }
          >
            <Logo width={sm ? 100 : 130} />
          </Grid.Col>
          <MediaQuery smallerThan="md" styles={{ display: "none" }}>
            <Grid.Col
              xs={6}
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "right",
              }}
            >
              <User />
              <ActionIcon onClick={toggleColorScheme}>
                {colorScheme === "dark" ? <IconSun /> : <IconMoonStars />}
              </ActionIcon>
            </Grid.Col>
          </MediaQuery>
        </Grid>
      </div>
    </HeaderMantine>
  );
}
